import { PlanOnboardingStep } from "@/services/SavingsPlanOnboarding.types";
import { ContractOnboardingStrings, getContractOnboardingStepCopy } from "@/screen/Map/contractOnboarding.strings";

/**
 * Tronco lineal del onboarding, en el mismo orden en que el backend encadena los pasos: `enabled`
 * de cada uno es el AND acumulado de los `completed` anteriores, así que un paso sin completar
 * apaga todas las tarjetas siguientes.
 */
export const LinearContractStepKeys = ["1.1", "2.1", "2.2", "2.2.2", "2.2.3", "2.3", "3.1", "4.1"];

export interface ContractMapBlockingStep
{
    key: string;
    title: string;
}

export function resolveContractMapBlockingStep(step: PlanOnboardingStep, steps: PlanOnboardingStep[]): ContractMapBlockingStep | null
{
    if(step.enabled)
    {
        return null;
    }

    const stepIndex = LinearContractStepKeys.indexOf(step.key);
    if(stepIndex < 0)
    {
        return null;
    }

    for(const key of LinearContractStepKeys.slice(0, stepIndex))
    {
        const previous = steps.find((candidate) => candidate.key === key);
        if(previous !== undefined && previous.completed === false)
        {
            return{
                key: previous.key,
                title: getContractOnboardingStepCopy(previous.key).title,
            };
        }
    }

    return null;
}

export function resolveContractMapBlockedNotice(step: PlanOnboardingStep, steps: PlanOnboardingStep[]): string | null
{
    if(step.enabled)
    {
        return null;
    }

    const blocking = resolveContractMapBlockingStep(step, steps);
    if(blocking === null)
    {
        return ContractOnboardingStrings.blockedStepPendingUnknown;
    }

    return ContractOnboardingStrings.blockedStepPending(blocking.key, blocking.title);
}
